
console.log("animation loaded");
function handleImageLoad(event) {
  const img = event.target;
  const container = img.closest(".img-and-loading-container");
  const loadingPlaceholder = container && container.querySelector(".image-loading");

  // Hide the loading placeholder when the image loads
  if (loadingPlaceholder) loadingPlaceholder.style.display = "none"; // Hide loading animation
  img.style.display = "block"; // Show the loaded image
}

function handleImageError(event) {
  const img = event.target;
  const container = img.closest(".img-and-loading-container");
  const loadingPlaceholder = container && container.querySelector(".image-loading");

  // Hide the loading placeholder if the image fails to load
  if (loadingPlaceholder) loadingPlaceholder.style.display = "none"; // Hide loading animation
  img.style.display = "none"; // Hide the image
}

function initializeImageLoading() {
  // Select all images in the product grid and product page (including newly loaded ones)
  const productImages = document.querySelectorAll(
    ".product-grid-image, .product-page-image"
  );

  // Add load and error event listeners to each image
  productImages.forEach((image) => {
    const container = image.closest(".img-and-loading-container");
    if (!container) return;
    const loadingPlaceholder = container.querySelector(".image-loading");

    // Already decoded (cached / back-navigation / bfcache restore): the `load`
    // event will NOT fire again, so we must NOT hide the image and wait on it —
    // that's the old bug where revisiting the grid left the spinner stuck on
    // forever. Just show the image, keep the spinner hidden, and move on.
    if (image.complete && image.naturalWidth > 0) {
      image.style.display = "block";
      if (loadingPlaceholder) loadingPlaceholder.style.display = "none";
      return;
    }

    // Genuinely still loading: hide the image, show the spinner, and let the
    // load/error handlers reveal it. No `src` reassignment — it doesn't
    // reliably re-fire `load`, and the listeners below already cover it.
    image.style.display = "none";
    if (loadingPlaceholder) loadingPlaceholder.style.display = "flex";

    image.addEventListener("load", handleImageLoad); // Load event
    image.addEventListener("error", handleImageError); // Error event
  });
}

document.addEventListener("DOMContentLoaded", function () {
  initializeImageLoading();
});

console.log("reset loaded");
window.addEventListener("pageshow", function (event) {
  if (event.persisted) {
    // Detect if page is loaded from cache (back button)
    // Select the element that had the hover effect
    let hoveredElement = document.querySelector(".product-grid-image");
    if (hoveredElement) {
      // Reset the hover styles by removing the class or resetting inline styles
      hoveredElement.classList.remove("hovered-class");
      hoveredElement.style.opacity = ""; // Reset any inline styles
    }
  }
});

// ── Shared collection-modal helpers ──────────────────────────────────────────
// Used by both script-index-filters.js (filter modal) and script-index-product.js
// (product-click modal). Previously each file carried its own byte-identical copy.

// Build the modal product grid: clone the matched containers, fix up lazy-loaded
// images (cloneNode drops their load listeners), inject into modalInner, append
// the footer, and return the cloned containers for the fade-in animation.
function buildModalGrid(sourceContainers, modalInner, appendModalFooter) {
  var grid = document.createElement("div");
  grid.className = "product-grid";
  grid.style.visibility = "visible";

  sourceContainers.forEach(function (original) {
    var clone = original.cloneNode(true);
    clone.style.display = "";
    clone.style.transition = "none";
    clone.style.opacity = "0";

    // cloneNode copies inline display:none from initializeImageLoading but not
    // the load event listeners, so images stay hidden on deep-link opens.
    var cloneImg = clone.querySelector(".product-grid-image");
    if (cloneImg) {
      var loadingEl = clone.querySelector(".image-loading");
      if (cloneImg.complete && cloneImg.naturalWidth > 0) {
        cloneImg.style.display = "block";
        if (loadingEl) loadingEl.style.display = "none";
      } else {
        cloneImg.removeAttribute("loading"); // prevent lazy-load deferral inside modal
        cloneImg.style.display = "none";
        cloneImg.addEventListener("load", function () {
          cloneImg.style.display = "block";
          if (loadingEl) loadingEl.style.display = "none";
        });
      }
    }

    grid.appendChild(clone);
  });

  modalInner.innerHTML = "";
  modalInner.appendChild(grid);
  if (typeof appendModalFooter === "function") appendModalFooter();

  // Every rebuild is a fresh collection — reset to the top. The modal is now in
  // document flow (not a fixed inner-scroll box), so the DOCUMENT is what scrolls;
  // resetting window scroll (not the element's scrollTop) is what puts the new
  // collection at the top. Callers capture the prior home scroll into
  // window.__indexHomeScrollY before this runs, and restore it on close.
  window.scrollTo(0, 0);

  return Array.from(grid.querySelectorAll(".product-grid-image-container"));
}

// Modal-title fade. opacity/transition live in CSS (#collection-modal-title +
// its .visible class); these only toggle the class so there's a single styling
// source of truth instead of inline opacity/transition writes.
function showModalTitle(title) {
  var el = document.getElementById("collection-modal-title");
  if (!el) return;
  el.textContent = title;
  el.classList.remove("no-transition");
  el.classList.add("visible");
}

function hideModalTitle() {
  var el = document.getElementById("collection-modal-title");
  if (!el) return;
  el.classList.remove("visible");
  setTimeout(function () {
    if (!el.classList.contains("visible")) el.textContent = "";
  }, 300);
}

// Instant (no-fade) variant used by the VIEW ALL restore path. Re-enables the
// transition next frame so a later hideModalTitle() still animates out.
function showModalTitleInstant(title) {
  var el = document.getElementById("collection-modal-title");
  if (!el) return;
  el.textContent = title;
  el.classList.add("no-transition");
  el.classList.add("visible");
  requestAnimationFrame(function () { el.classList.remove("no-transition"); });
}

console.log("ln captured");
// Immediately change the body style to black
document.body.style.backgroundColor = "black";

// Check the user's language and navigate to /en if it's English
if (
  navigator.language.startsWith("en") &&
  !window.location.pathname.startsWith("/en")
) {
  window.location.replace("/en");
}
